import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'
import { WorkflowEventType, WorkflowLogMetadata } from './useBatchSync'

export interface WorkflowLogOperator {
  name: string
  avatarUrl?: string
}

export interface WorkflowLogApiEvent {
  eventType: WorkflowEventType
  occurredAt: string
  taskId: string
  metadata: WorkflowLogMetadata
  operator: WorkflowLogOperator
}

export interface WorkflowLogResponse {
  logs: WorkflowLogApiEvent[]
}

export const WORKFLOW_LOGS_QUERY_KEY = 'workflow-logs'

export function useGetByEngagementId(engagementId?: string) {
  return useQuery({
    queryKey: [WORKFLOW_LOGS_QUERY_KEY, engagementId],
    queryFn: async () => {
      const { data } = await apiClient.get<WorkflowLogResponse>(
        `/int/v3/workflow-logs?engagementId=${engagementId}`
      )
      return data
    },
    enabled: !!engagementId,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  })
}
